<template>
  <data-form
    :entity="formValue"
    :fields="fields"
    model="switches"
  />
</template>

<script>
export default {
  name: 'server-switch-form',
  props: {
    switchx: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      fields: {
        'usage': {
          type: 'select',
          options: [
            { label: 'switch.entry-point', value: 'entry-point' },
            { label: 'switch.hidden', value: 'hidden' },
            { label: 'switch.system', value: 'system' }
          ]
        },
        'systemForm': {
          type: 'hidden'
        }
      }
    }
  },
  computed: {
    formValue () {
      return { ...this.switchx, 'systemForm': 1 }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ServerSwitchForm.vue?03789f10